export default __webpack_public_path__ + "static/media/linkedin.2718c79a.svg";